module.exports = __webpack_public_path__ + "static/media/mq.04051216.svg";